import React from 'react';
import isEmpty from 'lodash/isEmpty';

import type { View } from 'common/types/view';
import type { GuidanceSummaryV2 } from 'common/types/approvals';

import { I18n } from 'common/i18n';
import currentUserCanFederate from 'common/views/current_user_can_federate';
import {
  ManageFederationsModal,
  ManageFederationsModalProps,
} from 'common/components/ManageFederationsModal';

import ActionItem from '../action_item';

export interface ManageFederationsActionItemProps {
  view: View;
  setCurrentModal: (
    modal: typeof ManageFederationsModal,
    // omitting 'onDismiss' because it's passed in by 'setCurrentModal'
    props: Omit<ManageFederationsModalProps, 'onDismiss'>,
  ) => void;
  approvalsGuidance: GuidanceSummaryV2;
}

export const ManageFederationsActionItem = ({
  view,
  setCurrentModal,
  approvalsGuidance,
}: ManageFederationsActionItemProps) => {
  // Don't render if view is empty or user doesn't have permission to federate
  if (isEmpty(view) || !currentUserCanFederate(view, approvalsGuidance)) {
    return null;
  }

  return (
    <ActionItem
      label={I18n.t('shared.components.asset_action_bar.publication_action.federate')}
      onClick={() =>
        setCurrentModal(ManageFederationsModal, {
          view,
        })
      }
    />
  );
};
